import { render, staticRenderFns } from "./EpotCreate.vue?vue&type=template&id=42f3c3dc&"
import script from "./EpotCreate.vue?vue&type=script&lang=js&"
export * from "./EpotCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports